import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue";
import GrupoViewModel from "@/shared/view-models/GrupoViewModel";
import AccountLoged from "@/shared/mixins/AccountLoged";

import GrupoController from "@/shared/controllers/grupo/grupoController";

const name = 'GerenciamentoGrupos'
export default {
  name,

  components: { 
    gCard,
    gForm,
    'g-button': gButton
  }, 

  props: { },
  mixins:[AccountLoged],

  mounted () { 
    if(!this.hasClaim('Gerenciamento-Grupos')) {
      this.$router.push('/sem-acesso')
    }
    this.getUsuariosLideres();
  },

  updated () { },

  data () {
    return { 
      UsuarioLiderArray: [],
      grupoViewModel: new GrupoViewModel,
      GrupoArray: [],
      popupInclusao: false,
      Colunas: [
        {field: 'nomeGrupo', header: 'Grupo'},
        {field: 'usuarioLider', header: 'Lider'},
      ], 
      mensagemvazio: true,
      popupExcluir: false,
      mensagem:''
    }
  },

  methods: {
    abrePopupExclusao(data){
      this.popupExcluir = true
      this.GrupoId = data.id
      this.nome = data.nomeGrupo
      this.mensagem = "Deseja mesmo excluir o grupo: " + this.nome + ' ?'
      
    },
    detalhesGrupo(data){
      this.$router.push(`/adicionar-grupo/${data.id}`)
    },
    excluir(){
      this.$isLoading(true)
      GrupoController.excluirGrupoById(this.GrupoId).requisicao
      .then((res=>{
      let result = res.data.message
      if(result != "Sucesso") {
        this.$toast.add({severity:'error', summary: 'ERRO', detail:'Esse grupo possui usuários vinculados',  life: 5000})
      }
      else{
        this.$toast.add({severity:'success', summary: 'SUCESSO', detail:'Grupo excluido com sucesso!',  life: 5000})
        this.popupExcluir = false
      }
      this.getGrupoByFiltro()
      }))
      .finally(() => this.$isLoading(false))
    },
    limpaFiltro() {
      this.grupoViewModel = new GrupoViewModel;
    },
    getGrupoByFiltro() {
      GrupoController.getGrupoByFiltro(this.grupoViewModel).requisicao
      .then((res => {
        this.mensagemvazio = false;
        this.GrupoArray = res.data.data
      }))
    },
    getUsuariosLideres() {
      GrupoController.getUsuariosLideres().requisicao
      .then((res => {
        this.UsuarioLiderArray = res.data.data
      }))
    }
   },

  computed: { }, 

};